import React from "react";

export const SubContainer = ({ children }) => {
  return (
    <div className={"sub_container"}>
      <div className={"contents mypage"}>{children}</div>
    </div>
  );
};
